<template>
    <ResponsiveIcon v-if="image"
                    :image-url="image.url"
                    :width="image.width"
                    :height="image.height"
                    :alt-text="altText"/>
    <div v-else/>
</template>

<script setup lang="ts">
import { Media } from '@/types/contentServerContract';
import ResponsiveIcon from '@/core/responsive/image/ResponsiveIcon.vue';

const props = defineProps<{
    image: Media;
    altText: string;
}>();
</script>
